import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { fetchCourseDetails,TakeSurveyAPI} from '../services/userApi';
import backgroundImage from '../assets/Bg.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCalendar, faClock } from '@fortawesome/free-regular-svg-icons';
import { useNavigate, Link,useLocation } from 'react-router-dom';
import backgroundImage2 from '../assets/bg2.jpg';

const Survey = () => {
    const navigate = useNavigate();
      const location = useLocation();
    const MySwal = withReactContent(Swal);
    const { surveyUid, courseUid } = location.state || {};
    const accessToken = JSON.parse(localStorage.getItem('account'))?.access_token;
    const [surveyData, setSurveyData] = useState(null);
    const [answers, setAnswers] = useState({});
    const [suggestion, setSuggestion] = useState('');
    const [unansweredQuestions, setUnansweredQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

        //Swal
        const onError = (title, response) => { 
            MySwal.fire({
                title: title,
                html: response?.data?.error?.message,
                icon: "error",
                confirmButtonText: "Close",
                allowOutsideClick: false,
            }).then(async (result) => {
              if (result.isConfirmed) {
                  if (response?.status === 401) {
                      sessionStorage.removeItem('hasVisited');
                      sessionStorage.removeItem('lastPath');        
                      localStorage.removeItem('account');                  
                      navigate('/');
                  }
              }
            });
        };
        
        const onSuccess = (title, message) => {
            MySwal.fire({
                icon: 'success',
                title: title,
                text: message,
                confirmButtonText: 'กลับสู่หน้าบทเรียน',
                confirmButtonColor: '#44526E',
                allowOutsideClick: false,
            });
        };

    useEffect(() => {
        getCourseDetails();
      }, [courseUid, accessToken, surveyUid]);
    
      const getCourseDetails = async () => {
        try {
            if (!courseUid) throw new Error('Course ID is missing.');
            if (!accessToken) throw new Error('Access token is missing.');
    
            const response = await fetchCourseDetails(courseUid, accessToken);
            console.log('API Response:', response);
    
            const { data } = response;
    
            if (data?.surveys && Array.isArray(data.surveys) && data.surveys.length > 0) {
                const survey = data.surveys.find(t => t.uid === surveyUid);
                if (survey) {
                    const sections = survey.surveys?.sections || [];
                    const questions = sections.reduce((acc, section) => {
                        return acc.concat(section.questions || []);
                    }, []);
    
                    // ตั้งค่า surveyData ครอบคลุมข้อมูลทั้งหมด
                    setSurveyData({
                        chapter: survey.chapter || 'ไม่พบข้อมูล chapter',
                        options: survey.surveys?.options || [],
                        sections: sections,
                        questions: questions,
                    });
                } else {
                    throw new Error('Survey not found.');
                }
            } else {
                throw new Error('Invalid surveys format received.');
            }
        } catch (error) {
            console.error('Error fetching course details:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => { 
        const survey_uid = surveyUid;
    
        if (!survey_uid) {
            console.error("Survey UID is missing");
            return;
        }
    
        const answersArray = Object.keys(answers).map(questionId => ({
            question_id: questionId,
            option_id: answers[questionId],
        }));
    
        const suggestionText = suggestion || '';
    
        // ตรวจสอบว่ามีคำถามที่ยังไม่ได้ตอบหรือไม่
        const unanswered = surveyData?.sections
            .flatMap(section => section.questions)
            .filter(question => !answers[question.question_id]);
    
        if (unanswered.length > 0) {
            setUnansweredQuestions(unanswered.map(q => q.question_id)); // เก็บคำถามที่ไม่ได้ตอบ
            return; // ไม่ส่งข้อมูลต่อหากมีคำถามที่ยังไม่ได้ตอบ
        }
    
        const payload = {
            questions: answersArray, // ใช้ answersArray ที่สร้างขึ้น
            suggestion: suggestionText // ใช้ suggestionText ที่ได้
        };
    
        try {
            const response = await TakeSurveyAPI(survey_uid, payload); // ส่ง payload ไปยัง API
            console.log('Survey submitted successfully:', response);
            Swal.fire({ 
                title: 'ส่งแบบสอบถามเรียบร้อย!',
                text: 'คุณได้ทำแบบสอบถามเรียบร้อยแล้ว',
                icon: 'success',
                confirmButtonText: 'กลับสู่หน้าบทเรียน',
                 confirmButtonColor: '#44526E'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/course', { state: { courseUid: courseUid ,activeTab: 'others'} });
                }
            });
        } catch (error) {
            console.error('Error submitting survey:', error);
            onError('Error', error.message || 'Unknown error occurred');
        }
    };
    

    const handleOptionChange = (questionId, optionId) => {
        setAnswers(prevAnswers => ({
            ...prevAnswers,
            [questionId]: optionId,
        }));
    };

    const handleBack = () => {
        navigate('/course', { state: { courseUid: courseUid, activeTab: 'others' } });
      };

    return (
        <main style={{ 
            backgroundImage: `url(${backgroundImage2})`,
            backgroundSize: 'cover',
            marginTop: '90px',
            position: 'relative',
            overflow: 'hidden',
        }}>
            <div style={styles.container}>
                    <div style={{
                        position: 'relative', // ตั้งค่า div หลักเป็น relative
                        width: '100%', // ให้ div ครอบคลุมความกว้างทั้งหมด
                        padding: '10px 0', // เพิ่ม padding ด้านบนและล่าง
                        boxSizing: 'border-box',
                        borderBottom: '1px solid black', 
                    }}>
                        <p style={{
                            margin: '0px',
                            fontSize: '1.5vw',
                            color: 'black',
                            width: '80%',
                            textAlign: 'left',
                            wordWrap: 'break-word', // ตัดบรรทัดเมื่อข้อความยาวเกิน
                            whiteSpace: 'normal',
                            padding:' 0 20px',
                            fontWeight:'bold'
                        }}>{surveyData?.chapter }</p> {/* หัวข้อใหญ่ */}

                        <div style={{
                            width: '20%', // ปรับให้เหมาะสมตามความต้องการ
                            position: 'absolute', // ใช้ absolute เพื่อให้ปุ่มอยู่ในมุมขวาบน
                            right: '0', // ทำให้ปุ่มชิดขวา
                            top: '0', // ทำให้ปุ่มอยู่ชิดด้านบน
                            padding: '10px', // เพิ่ม padding เพื่อความสวยงาม
                            textAlign:'right'
                        }}>
                        </div>
                    </div>
                    <div style={styles.section}>
                        {surveyData?.sections?.map((section) => (
                            <div key={section.section_id} style={styles.sectionContainer}>
                                
                                {/* ส่วนแสดงตัวเลือก (Option Text) ที่ด้านบนของ section */}
                                <div style={styles.optionTextRow}>
                                    {/* ส่วนที่ 1 ครอบคลุม 50% */}
                                    <div style={{ width: '50%' ,}}>
                                        {/* เว้นระยะห่างด้านหน้า */}
                                        <h3 style={styles.sectionTitle}>{section.section_text}</h3>
                                    </div>
                                    {/* ส่วนที่ 2 ครอบคลุม 50% */}
                                    <div style={{ width: '50%', textAlign: 'left', display:'flex',justifyContent:'space-around',alignItems:'center' }}> {/* หรือเปลี่ยนเป็น textAlign: 'right' หากต้องการให้อยู่ฝั่งขวา */}
                                        {surveyData?.options?.map((option) => (
                                        <div key={option.option_id} style={styles.optionText}>
                                            {option.option_text}
                                        </div>
                                        ))}
                                    </div>
                                </div>
                                {/* แสดงคำถามใน section นั้นๆ */}
                                {section.questions?.map((question) => {
                                    const isUnanswered = unansweredQuestions.includes(question.question_id); // ตรวจสอบว่าคำถามนี้ไม่ได้ตอบหรือไม่
                                    return (
                                        <div key={question.question_id} 
                                            style={{ 
                                                border: isUnanswered ? '1px solid red' : '1px solid #dddddd', 
                                                padding: '10px', 
                                                marginBottom: '10px', 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                background: isUnanswered ? '#FF00004D' :'#f2f2f2',
                                                alignItems: 'center',
                                                borderRadius: '8px'
                                            }}>
                                            <div style={{
                                                width: '50%',
                                                wordWrap: 'break-word', // ตัดบรรทัดเมื่อข้อความยาวเกิน
                                                overflow: 'hidden',     // ซ่อนข้อความที่ล้นออกจากกรอบ
                                                textOverflow: 'ellipsis', // ใส่ ... เมื่อข้อความถูกตัด
                                                whiteSpace: 'normal',    // ให้ข้อความตัดบรรทัด
                                            }}>
                                                {question.question_text}
                                            </div>
                                            <div style={{ display: 'flex', width: '50%', justifyContent: 'space-around' }}>
                                                {surveyData?.options?.map((option) => (
                                                    <div key={option.option_id} style={styles.radioWrapper}>
                                                        <input
                                                            type="radio"
                                                            name={`question_${question.question_id}`}
                                                            value={option.option_id}
                                                            onChange={() => handleOptionChange(question.question_id, option.option_id)}
                                                            style={{
                                                                width: '32px',
                                                                height: '32px',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>
                        ))}
                    </div>
                    <div>
                        <textarea
                                placeholder="ข้อเสนอแนะเพิ่มเติม..."
                                value={suggestion}
                                onChange={(e) => setSuggestion(e.target.value)}
                                style={styles.textArea}
                            />
                    </div>
                    <div style={styles.SurveyBTN}>
                        <div style={{ width: '50%' }}>
                            <button style={styles.BackButton} onClick={handleBack}>
                            ย้อนกลับ
                            </button>
                        </div>
                        <div style={{ width: '50%' }}>
                            <button style={styles.submitButton} onClick={handleSubmit}>
                            ส่งแบบประเมิน
                            </button>
                        </div>
                    </div>
                </div>
        </main>
    ); 
};
const styles = {
    background: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.25)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: '-1',
        boxSizing: 'border-box',
    },  
    container:{
        boxSizing: 'border-box',
        background:' #FFFFFFB2',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '95%',
        borderRadius: '36px',
        margin: '25px auto', // จัดให้อยู่ตรงกลางในแนวนอน
        padding: '24px 196px',
        textAlign: 'left',
        gap:'24px'  
    },
    sectionTitle: {
        fontSize: '1vw',
        margin: '10px 0',
        wordWrap: 'break-word', // ตัดบรรทัดเมื่อคำยาวเกินไป
        whiteSpace: 'normal',   // อนุญาตให้ตัดบรรทัด
        overflow: 'hidden',     // ซ่อนข้อความที่เกินพื้นที่
    },
    optionTextRow: {
        display: 'flex',     // จัดให้ radio buttons เรียงในแนวนอน
        justifyContent: 'space-between',
        width: '100%',       // ครอบคลุมพื้นที่ทั้งหมด
        padding:'10px',
        boxSizing:'border-box',
        background:'#cccccc',
        border:'1px solid #dddddd',
        margin:'16px 0',
        borderRadius:'16px'
    },
    optionText: {
        width: '40px', // กำหนดความกว้างให้กับ option text
        textAlign: 'center', // จัด text ให้อยู่ตรงกลางในแต่ละช่อง
        fontSize: '1vw',
       boxSizing:'border-box'
    },
    questionRow: {
        display: 'flex', // จัดคำถามกับ radio buttons ให้อยู่ในแนวนอน
        alignItems: 'center', // จัดให้อยู่ตรงกลางแนวตั้ง
    },
    radioButtonsRow: {
       display: 'flex',     // จัดให้ radio buttons เรียงในแนวนอน
       justifyContent: 'space-between',
       width: '100%',       // ครอบคลุมพื้นที่ทั้งหมด
       gap:'32px',
      fontSize:'24px'
    },
    radioWrapper: {
      alignItems:'center'
    },
    questionAndRadioContainer:{
        display : 'flex',
    },
    textArea:{
        width:'100%',
        border:'none',
        boxSizing:'border-box',
        height:'150px',
        resize: 'vertical',
        padding:'20px',
        fontSize: '0.8vw',
        borderRadius:'20px',
        background:'white'
    },
    submitButton: {
        width: '100%',
        borderRadius: '64px',
        background: '#44526e',
        boxShadow: '0px 4px 42px 0px #001D6740',
        border: 'none',
        fontSize: '1vw',
        color: 'white',
        cursor: 'pointer',
        padding: '10px 24px',
      },
      BackButton: {
        width: '100%',
        borderRadius: '64px',
        background: '#ffffff',
        boxShadow: '0px 4px 42px 0px #001D6740',
        border: 'none',
        fontSize: '1vw',
        color: '#44526e',
        cursor: 'pointer',
        padding: '10px 24px',
      },
      SurveyBTN: {
        display: 'flex',
        width: '100%',
        gap: '24px', // ระยะห่างระหว่างปุ่ม
        justifyContent: 'space-between',
        alignItems: 'center',
        margin:'24px 0'
      },
};

export default Survey;